/* eslint-disable */
import React from 'react';
import { Button, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

export interface ErrorModalError {
    description?: string;
    arDescription?: string;
}

export interface ErrorModalProps {
    visible: boolean;
    error: ErrorModalError | null;
    onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ visible, error, onClose }) => {
    const { t, i18n } = useTranslation('ksaApplication');
    const isArabic = i18n.language.slice(0, 2) === 'ar';

    const errorMessage =
        error?.arDescription && isArabic ? error.arDescription : error?.description;

    return (
        <Modal
            style={{ textAlign: 'center' }}
            open={visible}
            title={<span dir={isArabic ? 'rtl' : 'ltr'}>{t('Issue Encountered')}</span>}
            onCancel={onClose}
            footer={
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        style={{ width: 220, backgroundColor: '#E12E56', color: '#FFFFFF' }}
                        onClick={onClose}
                    >
                        {t('Try Again')}
                    </Button>
                </div>
            }
            centered
        >
            <Typography.Paragraph dir={isArabic ? 'rtl' : 'ltr'}>
                {errorMessage}
            </Typography.Paragraph>
        </Modal>
    );
};

export default ErrorModal;
